import { IContainerType } from "../types/IContainerType";
import { TTextureSizeEnum } from "../enums/TTextureSizeEnum";

export function getTextureName(
  carrierName: string,
  containerType: IContainerType,
  size: TTextureSizeEnum,
  format: "png" | "jpg" | "webp",
): string {
  return `${carrierName}-${containerType}-${size}.${format}`;
}
